module.exports = __webpack_public_path__ + "fonts/Roboto-300-symbols27.8feefe1.woff2";